import { useNavigate } from "react-router-dom"
import { observer, useLocalObservable } from "mobx-react"
import { Button, Card, Flex, Form, theme, Typography } from "antd"
import { useForm } from "antd/es/form/Form"
import { InboxOutlined } from "@ant-design/icons"

import downloadIcon from "@src/app/assets/icons/downloadCircle.svg"
import { paths } from "@src/app/paths"
import { MassPayoutsCollection } from "@src/pages/massPayouts/crypto/classess/MassPayoutsCryptoCollection"
import { ManualPayoutsFormFee } from "@src/pages/massPayouts/crypto/ui/manual/ManualPayoutsFormFee"
import { GlobalPayoutsConformationProcess } from "@src/pages/payoutsConfirmation/classes/PayoutsConformationProcess"
import { catchErrors } from "@src/shared/api"
import { ImageUploaderUI } from "@src/shared/componemts/ImageUploadUI"
import { Uploaded } from "@src/shared/componemts/ImageUploadUI/entity/Uploaded"
import css from "../../index.module.css"

type MassPayoutsFormProps = {
  collection: MassPayoutsCollection
}
export const MassPayoutsForm = observer(
  ({ collection }: MassPayoutsFormProps) => {
    const i = useLocalObservable(() => new Uploaded())
    const { token } = theme.useToken()

    const [f] = useForm()

    const nav = useNavigate()

    const onSendFunds = async () => {
      const formData = new FormData()

      formData.append("payouts", i._state?.source?.originFileObj as Blob)

      formData.append("id", crypto.randomUUID())

      formData.append("fee_payer", f.getFieldValue("fee_payer"))

      formData.append("with_confirmation", "true")

      return collection
        .createMassPayoutFormData(formData)
        .then((res) => {
          if (res) {
            nav(paths.payoutsConfirmation)
            GlobalPayoutsConformationProcess().setState({
              id: res.id,
              payouts: res.payouts,
              type: "crypto",
            })
          }
        })
        .catch(catchErrors)
    }

    return (
      <Form
        form={f}
        id="GENERATED_ID_MASSPAYOUTSFORM_FORM_VOID_1"
        initialValues={{ fee_payer: "merchant" }}
      >
        <Flex gap={32} vertical>
          <Flex gap={32} justify={"space-between"}>
            <ImageUploaderUI
              accept={".csv"}
              control={i}
              placeholder={
                <>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ color: token.colorPrimary }} />
                  </p>
                  <p className="ant-upload-text">Click to upload CSV file</p>
                </>
              }
            />

            <Card
              bordered={false}
              className={css.downloadWrapper}
              hoverable
              size="small"
              style={{ maxHeight: 180, minWidth: 200 }}
            >
              <Typography.Link
                href={require("@src/app/example/example.csv")}
                style={{ display: "block", height: "100%" }}
              >
                <Flex
                  align="center"
                  gap={16}
                  justify="center"
                  style={{ height: "100%", width: "100%" }}
                  vertical
                >
                  <img alt="icon" src={downloadIcon} />
                  Download example.CSV
                </Flex>
              </Typography.Link>
            </Card>
          </Flex>

          <Flex align={"center"} gap={32} justify="space-between">
            <ManualPayoutsFormFee />
            <Button
              disabled={!i.hasFile}
              id="GENERATED_ID_MASSPAYOUTSFORM_BUTTON_PRECHECK_1"
              loading={collection.isLoading || i.isLoading}
              onClick={onSendFunds}
              size="large"
              type="primary"
            >
              Pre-Check
            </Button>
          </Flex>
        </Flex>
      </Form>
    )
  },
)
